import {useEffect, useState} from "react";

import {useSwapFlowState} from "../../flow/context/SwapFlowContext";
import {SwapFlowView} from "../../flow/context/SwapFlowContext.types";
import {SwapFormDispatchContext, SwapFormStateContext} from "../context/SwapFormContext";
import useSwapForm from "../util/hook/useSwapForm";
import SwapForm from "../SwapForm";
import SignFlow from "../../../core/sign-flow/SignFlow";
import Typography from "../../../component/typography/Typography";
import {generateSwapFormAssetIDs} from "../SwapForm.utils";
import SwapError from "../../error/SwapError";
import SwapFormErrorView from "../error-view/SwapFormErrorView";
import {getPlatformFeeError} from "../../../core/widgetUtils";
import useAsyncProcess from "../../../core/network/async-process/useAsyncProcess";

function SwapFormContainer() {
  const {view} = useSwapFlowState();
  const {assetInID, assetOutID} = generateSwapFormAssetIDs();
  const {state, dispatch} = useSwapForm({
    assetInID,
    assetOutID,
    onError: handleError
  });
  const [swapError, setSwapError] = useState<SwapError | null>(null);

  const {
    state: platformFeeErrorAsyncProcessState,
    runAsyncProcess: runPlatformFeeErrorAsyncProcess
  } = useAsyncProcess<Error | null>();

  useEffect(() => {
    runPlatformFeeErrorAsyncProcess(getPlatformFeeError(assetInID!, assetOutID!));
  }, [assetInID, assetOutID, runPlatformFeeErrorAsyncProcess]);

  return (
    <SwapFormDispatchContext.Provider value={dispatch}>
      <SwapFormStateContext.Provider value={state}>
        {renderContent()}
      </SwapFormStateContext.Provider>
    </SwapFormDispatchContext.Provider>
  );

  function renderContent() {
    const error = platformFeeErrorAsyncProcessState.data || swapError;

    if (error) {
      return <SwapFormErrorView error={error} />;
    }

    switch (view) {
      case SwapFlowView.Form:
        return <SwapForm />;
      case SwapFlowView.Sign:
        return <SignFlow />;
      default:
        return (
          <Typography fontWeight={"bold"}>
            {"Unknown error has occured! Please try again later."}
          </Typography>
        );
    }
  }

  function handleError(error: SwapError) {
    setSwapError(error);
  }
}

export default SwapFormContainer;
